<template>
  <v-chip v-bind="$attrs" :color="color">{{ statusText }}</v-chip>
</template>

<script>
import statuses from "@/booking-statuses"

const colors = {
  1: "warning",
  2: "danger",
  3: "success",
}

export default {
  props: {
    status: {
      type: Number,
      required: true,
    },
  },
  computed: {
    color() {
      return colors[this.status]
    },
    statusText() {
      return statuses[this.status]
    },
  },
}
</script>
